import script from "./withdrawList.vue?vue&type=script&setup=true&lang=js"
export * from "./withdrawList.vue?vue&type=script&setup=true&lang=js"

import "./withdrawList.vue?vue&type=style&index=0&id=13ef131c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13ef131c"]])

export default __exports__